"use strict";
export var GQLQueries = /* @__PURE__ */ ((GQLQueries2) => {
  GQLQueries2["Nfts"] = "Nfts";
  GQLQueries2["NFTItemScreen"] = "NFTItemScreen";
  GQLQueries2["NftCollectionScreen"] = "NftCollectionScreen";
  GQLQueries2["NftsTab"] = "NftsTab";
  GQLQueries2["PortfolioBalances"] = "PortfolioBalances";
  GQLQueries2["SelectWalletScreen"] = "SelectWalletScreen";
  GQLQueries2["TransactionHistoryUpdater"] = "TransactionHistoryUpdater";
  GQLQueries2["Token"] = "Token";
  GQLQueries2["TokenDetailsScreen"] = "TokenDetailsScreen";
  GQLQueries2["TokenPriceHistory"] = "TokenPriceHistory";
  GQLQueries2["TokenProjects"] = "TokenProjects";
  GQLQueries2["TransactionList"] = "TransactionList";
  GQLQueries2["TopTokens"] = "TopTokens";
  GQLQueries2["SearchTokens"] = "SearchTokens";
  GQLQueries2["ExploreSearch"] = "ExploreSearch";
  GQLQueries2["SpotPrices"] = "SpotPrices";
  GQLQueries2["ExploreTokensTab"] = "ExploreTokensTab";
  GQLQueries2["FavoriteTokenCard"] = "FavoriteTokenCard";
  return GQLQueries2;
})(GQLQueries || {});
